export default "__VITE_ASSET__CR4w$mC4__"